<template>
  <div class="p-3 pt-5 term-and-condition">
    <b-container>
      <b-row class="justify-content-end">
        <b-col xl="10" class="ml-auto mr-auto">
          <h3 class="text-center mb-4 fz-20">{{ $t("Terms of Use") }}</h3>
          <p class="text-justify">
            Welcome to {{ companyName }}. These Terms and Conditions ("Terms") govern your use of our card solutions, services, and website. By accessing or using {{ companyName }} products or services, you agree to be bound by these Terms. Please read them carefully.
          </p>
          <div id="accordion">
            <term1 :companyName="companyName"/>
            <term2 :companyName="companyName"/>
            <term3 :companyName="companyName"/>
            <term4 :companyName="companyName"/>
            <term5 :companyName="companyName"/>
            <term6 :companyName="companyName"/>
            <term7 :companyName="companyName"/>
            <term8 :companyName="companyName"/>
            <term9 :companyName="companyName"/>
            <term10 :companyName="companyName"/>
            <term11 :companyName="companyName"/>
            <term12 :companyName="companyName"/>
            <term13 :companyName="companyName"/>
            <term14 :companyName="companyName"/>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import term1 from "@/components/termCondition/terms/term1.vue";
import term2 from "@/components/termCondition/terms/term2.vue";
import term3 from "@/components/termCondition/terms/term3.vue";
import term4 from "@/components/termCondition/terms/term4.vue";
import term5 from "@/components/termCondition/terms/term5.vue";
import term6 from "@/components/termCondition/terms/term6.vue";
import term7 from "@/components/termCondition/terms/term7.vue";
import term8 from "@/components/termCondition/terms/term8.vue";
import term9 from "@/components/termCondition/terms/term9.vue";
import term10 from "@/components/termCondition/terms/term10.vue";
import term11 from "@/components/termCondition/terms/term11.vue";
import term12 from "@/components/termCondition/terms/term12.vue";
import term13 from "@/components/termCondition/terms/term13.vue";
import term14 from "@/components/termCondition/terms/term14.vue";

export default {
  name: "term-condition",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      companyName:process.env.VUE_APP_COMPANY_NAME
    };
  },
  components: {
    term1,
    term2,
    term3,
    term4,
    term5,
    term6,
    term7,
    term8,
    term9,
    term10,
    term11,
    term12,
    term13,
    term14,
  },
  methods: {},
  mounted() {},
};
</script>
<style scoped>
ol,
ul,
li {
  font-size: 1rem;
  font-weight: 300;
  line-height: 2rem;
}
a {
  color: #5e72e4 !important;
  font-size: 1rem;
  font-weight: 300;
}
</style>
